module.exports = __webpack_public_path__ + "dj.svg?694ca31b23013c8f1127e23741dd54a0";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/dj.svg
// module id = 1324
// module chunks = 0